const BLOCKLIST_CHARS = [
  // Svasti characters
  '\u0FD5',
  '\u0FD6',
  '\u0FD7',
  '\u0FD8',
];

/**
 * Returns true if we want to block a character from any of our CharPickers.
 */
export default function isCharBlocked(char: string): boolean {
  return BLOCKLIST_CHARS.includes(char);
}
